import { Grid, FormControlLabel, Switch } from '@mui/material';
import { FC } from 'react';
import { FiltersLayout, SearchField } from '../../../../../components';

interface IListManagementFilters {
  isLoading: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
  isActive: boolean;
  setIsActive: (val: boolean) => void;
}

export const ListManagementFilters: FC<IListManagementFilters> = ({
  isLoading,
  handleSearch,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  setIsActive,
  isActive
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={8}>
        <FormControlLabel
          color="primary"
          control={
            <Switch
              checked={isActive}
              id="list-management-switch"
              onChange={(_, checked) => setIsActive(checked)}
              name={'list-management-switch'}
            />
          }
          label="Only Active"
        />
      </Grid>
    </FiltersLayout>
  );
};
